import axios from 'axios';
import config from '../config/apiConfig';

// 1. Agregamos el /api/ que es como lo definimos en Python
const API_URL = `${config.api_url}/api/variantes-plantillas`; 

// Función para obtener los headers con el token automáticamente
const getHeaders = () => ({
    headers: { 'token': localStorage.getItem('token') }
});

// 2. Usamos axios en todas para que sea consistente
export const obtenerPlantillas = async () => {
    try {
        const res = await axios.get(API_URL, getHeaders());
        return res.data; // Axios ya devuelve el JSON en .data
    } catch (error) {
        console.error("Error al obtener plantillas:", error);
        return [];
    }
};

export const crearPlantilla = (data) => {
    // 🚩 IMPORTANTE: Aquí también se necesita el token para que Python te deje guardar
    return axios.post(API_URL, data, getHeaders());
};

export const eliminarPlantilla = (id) => {
    return axios.delete(`${API_URL}/${id}`, getHeaders());
};